import { render, staticRenderFns } from "./UboiLogo.vue?vue&type=template&id=df587976&"
import script from "./UboiLogo.vue?vue&type=script&lang=ts&"
export * from "./UboiLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports